import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  Filler,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);

interface DayAheadMarketPriceChartProps {
  belpexData: Array<{
    dtlt: string;
    price: number;
  }>;
}

const DayAheadMarketPriceChart: React.FC<DayAheadMarketPriceChartProps> = ({ belpexData }) => {
  if (!belpexData || belpexData.length === 0) return null; // Safety check
  console.log(belpexData);
  const chartData = {
    labels: belpexData.map((item) =>
      new Date(item.dtlt).toLocaleDateString('en-US', {
        year: 'numeric',
        day: 'numeric',
        month: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    ),
    datasets: [
      {
        label: 'Day Ahead Market Price (€)',
        data: belpexData.map((item) => item.price),
        borderColor: '#cbc800',
        backgroundColor: '#faf9cb',
        borderWidth: 0.75,
        stepped: 'middle' as const,
        fill: true,
        pointRadius: 0,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: 'top' as const,
        labels: {
          font: {
            size: 20, // Adjust font size
            weight: 'normal' as const,
          },
          color: '#006087',
        },
      },

      tooltip: {
        mode: 'index' as const,
        intersect: false,
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Time',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 8,
          color: '#006087',
          minRotation: 10,
          maxRotation: 40,
        },
        grid: {
          color: '#ffffff6a',
        },
      },
      y: {
        title: {
          display: false,
          text: 'Price (€)',
          color: '#006087',
        },
        grid: {
          color: '#d2e3ea6a',
        },
        ticks: {
          color: '#006087',
        },
        beginAtZero: false,
      },
    },
  };

  return (
    <div className='mt-6 overflow-x-auto'>
      <div style={{ minWidth: '800px', height: '500px' }}>
        <Line data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default DayAheadMarketPriceChart;
